var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPulse = function SvgPulse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M12.1 0c2.43 0 4.4 2.027 4.4 4.865 0 5.675-6 8.919-8 10.135-1.582-.962-5.667-3.193-7.305-6.892h3.758L5.7 6.846 8.1 10.9l1.653-2.792H12.5V6.486H8.847L8.1 7.748 5.7 3.694 4.047 6.486H.668A7.846 7.846 0 0 1 .5 4.865C.5 2.027 2.5 0 4.9 0c1.488 0 2.8.81 3.6 1.622C9.3.81 10.612 0 12.1 0Z"
  })));
};
export default SvgPulse;